import { EventObject } from '@xstate/store-react';
import { StoreContext } from '../../../models/store/context';
import { AppStatus } from '../../../models/store/appStatus';
import { AppRoute } from '../../../enums/appRoutes';
import { log } from '@domgen/shared/utils/log';
import { StoreEvent } from '../../../enums/storeEvent';

export const catalogueFailed = <T extends EventObject | undefined = EventObject>(
  context: StoreContext,
  _event: T,
  enqueue: {
    effect: (effect: () => Promise<void>) => void;
    emit: { navigate: (payload: { path: AppRoute; replace?: boolean }) => void };
  },
): StoreContext => {
  log.debug({ message: StoreEvent.GET_CATALOGUE_FAILED });
  enqueue.emit.navigate({ path: AppRoute.ERROR, replace: true });
  return {
    ...context,
    app: {
      ...context.app,
      status: AppStatus.ERROR,
    },
  };
};
